import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetBeneficiary,
	GetBeneficiaryModel,
	GetBeneficiaryParams,
} from 'domain/usecases/others/selection-flow/beneficiary-v3';

export class RemoteGetBeneficiary implements GetBeneficiary {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetBeneficiaryModel>,
	) {}

	async get({signal, ...params}: GetBeneficiaryParams): Promise<GetBeneficiaryModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
